export const ColorOrange100 = "#fee3dc";
export const ColorOrange200 = "#fda891";
export const ColorOrange300 = "#ff8f70";
export const ColorOrange400 = "#fc7753";
export const ColorOrange500 = "#fa4616"; // Primary Brand Orange
export const ColorOrange600 = "#da3b11";
export const ColorOrange700 = "#c2320c";
export const ColorOrange800 = "#832107";
export const ColorOrange850 = "#3c383c";
export const ColorOrange100Contrast = "#182027";
export const ColorOrange200Contrast = "#182027";
export const ColorOrange300Contrast = "#182027";
export const ColorOrange400Contrast = "#182027";
export const ColorOrange500Contrast = "#182027";
export const ColorOrange600Contrast = "#f4f9fa";
export const ColorOrange700Contrast = "#f4f9fa";
export const ColorOrange800Contrast = "#f4f9fa";
export const ColorBlue100 = "#dae8fa";
export const ColorBlue200 = "#badaff";
export const ColorBlue300 = "#87bfff";
export const ColorBlue400 = "#66adff";
export const ColorBlue500 = "#0067df";
export const ColorBlue600 = "#0056ba";
export const ColorBlue700 = "#00489d";
export const ColorBlue800 = "#00336f";
export const ColorBlue050 = "#f5f9fe";
export const ColorBlue050Contrast = "#1b2630";
export const ColorBlue100Contrast = "#182027";
export const ColorBlue200Contrast = "#182027";
export const ColorBlue300Contrast = "#182027";
export const ColorBlue400Contrast = "#182027";
export const ColorBlue500Contrast = "#f4f9fa";
export const ColorBlue600Contrast = "#f4f9fa";
export const ColorBlue700Contrast = "#f4f9fa";
export const ColorBlue800Contrast = "#f4f9fa";
export const ColorBlueSecondary100 = "#e9f1fa";
export const ColorBlueSecondary200 = "#b2d2f3";
export const ColorBlueSecondary300 = "#8cc2f8";
export const ColorBlueSecondary400 = "#42a1ff";
export const ColorBlueSecondary500 = "#1976d2"; // Brand Accessory Blue Secondary
export const ColorBlueSecondary600 = "#1665b3";
export const ColorBlueSecondary700 = "#11508d";
export const ColorBlueSecondary800 = "#0c3761";
export const ColorBlueSecondary100Contrast = "#182027";
export const ColorBlueSecondary200Contrast = "#182027";
export const ColorBlueSecondary300Contrast = "#182027";
export const ColorBlueSecondary400Contrast = "#182027";
export const ColorBlueSecondary500Contrast = "#f4f9fa";
export const ColorBlueSecondary600Contrast = "#f4f9fa";
export const ColorBlueSecondary700Contrast = "#f4f9fa";
export const ColorBlueSecondary800Contrast = "#f4f9fa";
export const ColorGreen100 = "#eeffe5";
export const ColorGreen200 = "#e4f2dd";
export const ColorGreen250 = "#e4f2dd";
export const ColorGreen300 = "#b4e89b";
export const ColorGreen400 = "#74c94b";
export const ColorGreen500 = "#6eb84a";
export const ColorGreen600 = "#539d2f";
export const ColorGreen700 = "#038108";
export const ColorGreen750 = "#038a08";
export const ColorGreen800 = "#005603";
export const ColorGreen250Contrast = "#182027";
export const ColorGreen500Contrast = "#182027";
export const ColorGreen750Contrast = "#f4f9fa";
export const ColorGreen050Contrast = "#182027";
export const ColorGreen050 = "#eeffe6";
export const ColorGreenEmerald = "#176245";
export const ColorYellow100 = "#fff3db";
export const ColorYellow200 = "#ffe19e";
export const ColorYellow300 = "#ffca55";
export const ColorYellow400 = "#ffbb27";
export const ColorYellow500 = "#ffb40e"; // Brand Accessory Yellow
export const ColorYellow600 = "#f3ab0d";
export const ColorYellow700 = "#9e6100";
export const ColorYellow750 = "#b27d09";
export const ColorYellow800 = "#805a07";
export const ColorYellow100Contrast = "#182027";
export const ColorYellow200Contrast = "#182027";
export const ColorYellow300Contrast = "#182027";
export const ColorYellow400Contrast = "#182027";
export const ColorYellow500Contrast = "#182027";
export const ColorYellow600Contrast = "#182027";
export const ColorYellow700Contrast = "#182027";
export const ColorYellow800Contrast = "#f4f9fa";
export const ColorRed100 = "#fff0f1";
export const ColorRed200 = "#ffd1d1";
export const ColorRed300 = "#ffadad";
export const ColorRed400 = "#ff8484";
export const ColorRed500 = "#cc3d45"; // Brand Accessory Red
export const ColorRed600 = "#b6242b";
export const ColorRed700 = "#a6040a";
export const ColorRed800 = "#6c0004";
export const ColorRed100Contrast = "#182027";
export const ColorRed200Contrast = "#182027";
export const ColorRed300Contrast = "#182027";
export const ColorRed400Contrast = "#182027";
export const ColorRed500Contrast = "#f4f9fa";
export const ColorRed600Contrast = "#f4f9fa";
export const ColorRed700Contrast = "#f4f9fa";
export const ColorRed800Contrast = "#f4f9fa";
export const ColorPurple100 = "#eee1ee";
export const ColorPurple200 = "#edb8ed";
export const ColorPurple300 = "#dc80db";
export const ColorPurple400 = "#b748b6";
export const ColorPurple500 = "#933692";
export const ColorPurple600 = "#8c338b";
export const ColorPurple700 = "#662565";
export const ColorPurple800 = "#491b49";
export const ColorPurple100Contrast = "#182027";
export const ColorPurple200Contrast = "#182027";
export const ColorPurple300Contrast = "#182027";
export const ColorPurple400Contrast = "#f4f9fa";
export const ColorPurple500Contrast = "#f4f9fa";
export const ColorPurple600Contrast = "#f4f9fa";
export const ColorPurple700Contrast = "#f4f9fa";
export const ColorPurple800Contrast = "#f4f9fa";
export const ColorLightBlue100 = "#e1f6fd";
export const ColorLightBlue200 = "#afe8fa";
export const ColorLightBlue300 = "#73d6f7";
export const ColorLightBlue400 = "#44cffc";
export const ColorLightBlue500 = "#38c6f4";
export const ColorLightBlue600 = "#35bbe7";
export const ColorLightBlue700 = "#278aab";
export const ColorLightBlue800 = "#1c637a";
export const ColorLightBlue100Contrast = "#182027";
export const ColorLightBlue200Contrast = "#182027";
export const ColorLightBlue300Contrast = "#182027";
export const ColorLightBlue400Contrast = "#182027";
export const ColorLightBlue500Contrast = "#182027";
export const ColorLightBlue600Contrast = "#182027";
export const ColorLightBlue700Contrast = "#182027";
export const ColorLightBlue800Contrast = "#f4f9fa";
export const ColorWhite = "#ffffff";
export const ColorBlack = "#000000";
export const ColorError100 = "#fff0f1";
export const ColorError200 = "#ffd1d1";
export const ColorError250 = "#ffa2a8";
export const ColorError300 = "#ffadad";
export const ColorError400 = "#ff8484";
export const ColorError500 = "#cc3d45";
export const ColorError600 = "#b6242b";
export const ColorError700 = "#a6040a";
export const ColorError750 = "#a6040a";
export const ColorError800 = "#6c0004";
export const ColorError250Contrast = "#182027";
export const ColorError500Contrast = "#182027";
export const ColorError750Contrast = "#f4f9fa";
export const ColorError050Contrast = "#182027";
export const ColorError050 = "#ffe6e7";
export const ColorWarning100 = "#fff3db";
export const ColorWarning200 = "#ffe19e";
export const ColorWarning300 = "#ffca55";
export const ColorWarning400 = "#ffbb27";
export const ColorWarning500 = "#ffb40e"; // Brand Accessory Yellow
export const ColorWarning600 = "#f3ab0d";
export const ColorWarning700 = "#b27d09";
export const ColorWarning750 = "#b27d09";
export const ColorWarning800 = "#805a07";
export const ColorWarning100Contrast = "#182027";
export const ColorWarning200Contrast = "#182027";
export const ColorWarning300Contrast = "#182027";
export const ColorWarning400Contrast = "#182027";
export const ColorWarning500Contrast = "#182027";
export const ColorWarning600Contrast = "#182027";
export const ColorWarning700Contrast = "#182027";
export const ColorWarning800Contrast = "#f4f9fa";
export const ColorInfo100 = "#e9f1fa";
export const ColorInfo200 = "#b2d2f3";
export const ColorInfo300 = "#8cc2f8";
export const ColorInfo400 = "#42a1ff";
export const ColorInfo500 = "#1976d2"; // Brand Accessory Blue Secondary
export const ColorInfo600 = "#1665b3";
export const ColorInfo700 = "#11508d";
export const ColorInfo800 = "#0c3761";
export const ColorInfo100Contrast = "#182027";
export const ColorInfo200Contrast = "#182027";
export const ColorInfo300Contrast = "#182027";
export const ColorInfo400Contrast = "#182027";
export const ColorInfo500Contrast = "#182027";
export const ColorInfo600Contrast = "#f4f9fa";
export const ColorInfo700Contrast = "#f4f9fa";
export const ColorInfo800Contrast = "#f4f9fa";
export const ColorSuccess100 = "#eeffe5";
export const ColorSuccess200 = "#e4f2dd";
export const ColorSuccess250 = "#e4f2dd";
export const ColorSuccess300 = "#b4e89b";
export const ColorSuccess400 = "#74c94b";
export const ColorSuccess500 = "#6eb84a";
export const ColorSuccess600 = "#539d2f";
export const ColorSuccess700 = "#038108";
export const ColorSuccess750 = "#038a08";
export const ColorSuccess800 = "#005603";
export const ColorSuccess250Contrast = "#182027";
export const ColorSuccess500Contrast = "#182027";
export const ColorSuccess750Contrast = "#f4f9fa";
export const ColorSuccess050Contrast = "#182027";
export const ColorSuccess050 = "#eeffe6";
export const ColorGray100 = "#f7f7f7";
export const ColorGray150 = "#f4f4f5";
export const ColorGray200 = "#ecedee";
export const ColorGray250 = "#e1e2e4";
export const ColorGray300 = "#d3d4d6";
export const ColorGray350 = "#c0c2c5";
export const ColorGray400 = "#aaacaf";
export const ColorGray450 = "#919295";
export const ColorGray500 = "#757679";
export const ColorGray550 = "#595a5c";
export const ColorGray600 = "#414244";
export const ColorGray650 = "#2d2e2f";
export const ColorGray700 = "#1d1d1e";
export const ColorGray750 = "#111212";
export const ColorGray800 = "#0a0a0a";
export const ColorGray850 = "#060606";
export const ColorGray100Contrast = "#182027";
export const ColorGray150Contrast = "#182027";
export const ColorGray200Contrast = "#182027";
export const ColorGray250Contrast = "#182027";
export const ColorGray300Contrast = "#182027";
export const ColorGray350Contrast = "#182027";
export const ColorGray400Contrast = "#182027";
export const ColorGray450Contrast = "#182027";
export const ColorGray500Contrast = "#f4f9fa";
export const ColorGray550Contrast = "#f4f9fa";
export const ColorGray600Contrast = "#f4f9fa";
export const ColorGray650Contrast = "#f4f9fa";
export const ColorGray700Contrast = "#f4f9fa";
export const ColorGray750Contrast = "#f4f9fa";
export const ColorGray800Contrast = "#f4f9fa";
export const ColorGray850Contrast = "#f4f9fa";
export const ColorGray050Contrast = "#182027";
export const ColorGray050 = "#fafafa";
export const ColorInk100 = "#f8f9fa";
export const ColorInk150 = "#f4f5f7";
export const ColorInk200 = "#e9f0f3";
export const ColorInk250 = "#dee6ea";
export const ColorInk300 = "#cfd8dd";
export const ColorInk350 = "#bbc7cd";
export const ColorInk400 = "#a4b1b8";
export const ColorInk450 = "#8a97a0";
export const ColorInk500 = "#6b7882";
export const ColorInk550 = "#526069";
export const ColorInk600 = "#374652";
export const ColorInk625 = "#374652"; // DEPRECATED - Please use ColorInk600 instead.
export const ColorInk650 = "#273139";
export const ColorInk700 = "#182027";
export const ColorInk750 = "#0e1419";
export const ColorInk800 = "#080c10";
export const ColorInk850 = "#04070a";
export const ColorInk100Contrast = "#182027";
export const ColorInk150Contrast = "#182027";
export const ColorInk200Contrast = "#182027";
export const ColorInk250Contrast = "#182027";
export const ColorInk300Contrast = "#182027";
export const ColorInk350Contrast = "#182027";
export const ColorInk400Contrast = "#182027";
export const ColorInk450Contrast = "#182027";
export const ColorInk500Contrast = "#f4f9fa";
export const ColorInk550Contrast = "#f4f9fa";
export const ColorInk600Contrast = "#f4f9fa";
export const ColorInk650Contrast = "#f4f9fa";
export const ColorInk700Contrast = "#f4f9fa";
export const ColorInk750Contrast = "#f4f9fa";
export const ColorInk800Contrast = "#f4f9fa";
export const ColorInk850Contrast = "#f4f9fa";
export const ColorInk050Contrast = "#182027";
export const ColorInk050 = "#182027";
export const ColorPink100 = "#fcdbe6";
export const ColorPink200 = "#f7a1bd";
export const ColorPink300 = "#fd7da7";
export const ColorPink400 = "#f25a8c";
export const ColorPink500 = "#ed145b";
export const ColorPink600 = "#d91153";
export const ColorPink700 = "#a60e3f";
export const ColorPink800 = "#76092d";
export const ColorBrandPrimary = "#fa4616"; // Brand color direct from marketing.
export const ColorBrandSecondary = "#0067df"; // Brand color direct from marketing.
export const ColorBrandNeutralWhite = "#ffffff";
export const ColorBrandNeutralBlack = "#000000";
export const ColorBrandNeutralDarkGray = "#595a5c";
export const ColorBrandNeutralPaleGray = "#e1e2e4";
export const ColorBrandNeutralLightGray = "#f4f5f7";
export const ColorBrandAccessoryRed = "#cc3d45";
export const ColorBrandAccessoryYellow = "#ffb40e";
export const ColorBrandAccessoryPurple = "#933692";
export const ColorBrandAccessoryLightBlue = "#38c6f4";
export const ColorBackgroundLight = "#ffffff";
export const ColorBackgroundLightHc = "#ffffff";
export const ColorBackgroundDark = "#182027";
export const ColorBackgroundSecondaryLight = "#f4f5f7";
export const ColorBackgroundSecondaryLightHc = "#f4f5f7";
export const ColorBackgroundSecondaryDark = "#273139";
export const ColorBackgroundInverseLight = "#182027";
export const ColorBackgroundInverseLightHc = "#182027";
export const ColorBackgroundInverseDark = "#f8f9fa";
export const ColorBackgroundGrayLight = "#cfd8dd";
export const ColorBackgroundGrayLightHc = "#cfd8dd";
export const ColorBackgroundGrayDark = "#526069";
export const ColorBackgroundDisabledLight = "#ecedee";
export const ColorBackgroundDisabledLightHc = "#ecedee";
export const ColorBackgroundDisabledDark = "#273139";
export const ColorBackgroundHighlightLight = "#fee3dc";
export const ColorBackgroundHighlightLightHc = "#fee3dc";
export const ColorBackgroundHighlightDark = "#3c383c";
export const ColorBackgroundRaisedLight = "#ffffff";
export const ColorBackgroundRaisedLightHc = "#ffffff";
export const ColorBackgroundRaisedDark = "#273139";
export const ColorBackgroundEditLight = "#ffffff";
export const ColorBackgroundEditLightHc = "#ffffff";
export const ColorBackgroundEditDark = "#00000099";
export const ColorBackgroundGrayEmpLight = "#a4b1b8";
export const ColorBackgroundGrayEmpLightHc = "#a4b1b8";
export const ColorBackgroundGrayEmpDark = "#8a97a0";
export const ColorBackgroundHoverLight = "#52606914"; // 14 hex = 0.08 Opacity
export const ColorBackgroundHoverLightHc = "#52606914"; // 14 hex = 0.08 Opacity
export const ColorBackgroundHoverDark = "#cfd8dd14"; // 14 hex = 0.08 Opacity
export const ColorBackgroundPressedLight = "#5260691f"; // 1f hex = 0.12 Opacity
export const ColorBackgroundPressedLightHc = "#5260691f"; // 1f hex = 0.12 Opacity
export const ColorBackgroundPressedDark = "#cfd8dd1f"; // 1f hex = 0.12 Opacity
export const ColorBackgroundSelectedLight = "#e9f1fa";
export const ColorBackgroundSelectedLightHc = "#e9f1fa";
export const ColorBackgroundSelectedDark = "#374652";
export const ColorSelectionIndicatorLight = "#0067df";
export const ColorSelectionIndicatorLightHc = "#00489d";
export const ColorSelectionIndicatorDark = "#66adff";
export const ColorNotificationIndicatorLight = "#da3b11";
export const ColorNotificationIndicatorLightHc = "#832107";
export const ColorNotificationIndicatorDark = "#ff8f70";
export const ColorHoverLight = "#e9f1fa";
export const ColorHoverLightHc = "#e9f1fa";
export const ColorHoverDark = "#374652";
export const ColorCurtainLight = "#000000";
export const ColorCurtainLightHc = "#000000";
export const ColorCurtainDark = "#000000";
export const ColorBorderLight = "#a4b1b8";
export const ColorBorderLightHc = "#6b7882";
export const ColorBorderDark = "#8a97a0";
export const ColorBorderDisabledLight = "#cfd8dd";
export const ColorBorderDisabledLightHc = "#cfd8dd";
export const ColorBorderDisabledDark = "#526069";
export const ColorBorderGridLight = "#f4f5f7";
export const ColorBorderGridLightHc = "#f4f5f7";
export const ColorBorderGridDark = "#273139";
export const ColorBorderDeEmpLight = "#cfd8dd";
export const ColorBorderDeEmpLightHc = "#a4b1b8";
export const ColorBorderDeEmpDark = "#526069";
export const ColorSelectionLight = "#da3b11";
export const ColorSelectionLightHc = "#832107";
export const ColorSelectionDark = "#ff8f70";
export const ColorLogoLight = "#fa4616";
export const ColorLogoLightHc = "#fa4616";
export const ColorLogoDark = "#ffffff";
export const ColorForegroundLight = "#273139";
export const ColorForegroundLightHc = "#273139";
export const ColorForegroundDark = "#f4f5f7";
export const ColorForegroundLightLight = "#6b7882";
export const ColorForegroundLightLightHc = "#526069";
export const ColorForegroundLightDark = "#a4b1b8";
export const ColorForegroundEmpLight = "#182027";
export const ColorForegroundEmpLightHc = "#182027";
export const ColorForegroundEmpDark = "#f8f9fa";
export const ColorForegroundDeEmpLight = "#526069";
export const ColorForegroundDeEmpLightHc = "#374652";
export const ColorForegroundDeEmpDark = "#cfd8dd";
export const ColorForegroundDisableLight = "#8a97a0";
export const ColorForegroundDisableLightHc = "#8a97a0";
export const ColorForegroundDisableDark = "#a4b1b8";
export const ColorForegroundInverseLight = "#f8f9fa";
export const ColorForegroundInverseLightHc = "#f8f9fa";
export const ColorForegroundInverseDark = "#182027";
export const ColorForegroundHighlightLight = "#da3b11";
export const ColorForegroundHighlightLightHc = "#832107";
export const ColorForegroundHighlightDark = "#ff8f70";
export const ColorForegroundHighlightSelectedLight = "#da3b111a";
export const ColorForegroundHighlightSelectedLightHc = "#8321071a";
export const ColorForegroundHighlightSelectedDark = "#ff8f701a";
export const ColorForegroundHighlightSelectedHoverLight = "#da3b1126";
export const ColorForegroundHighlightSelectedHoverLightHc = "#83210726";
export const ColorForegroundHighlightSelectedHoverDark = "#ff8f7026";
export const ColorForegroundLinkLight = "#0067df";
export const ColorForegroundLinkLightHc = "#00489d";
export const ColorForegroundLinkDark = "#66adff";
export const ColorForegroundLinkPressedLight = "#00489d";
export const ColorForegroundLinkPressedLightHc = "#00336f";
export const ColorForegroundLinkPressedDark = "#badaff";
export const ColorForegroundInvDeEmpLight = "#cfd8dd";
export const ColorForegroundInvDeEmpLightHc = "#cfd8dd";
export const ColorForegroundInvDeEmpDark = "#526069";
export const ColorPrimaryLight = "#0067df";
export const ColorPrimaryLightHc = "#00489d";
export const ColorPrimaryDark = "#66adff";
export const ColorPrimaryLighterLight = "#badaff";
export const ColorPrimaryLighterLightHc = "#badaff";
export const ColorPrimaryLighterDark = "#00489d";
export const ColorPrimaryDarkerLight = "#00489d";
export const ColorPrimaryDarkerLightHc = "#11508d";
export const ColorPrimaryDarkerDark = "#badaff";
export const ColorPrimaryHoverLight = "#0056ba";
export const ColorPrimaryHoverLightHc = "#00336f";
export const ColorPrimaryHoverDark = "#87bfff";
export const ColorPrimaryFocusedLight = "#0056ba";
export const ColorPrimaryFocusedLightHc = "#00336f";
export const ColorPrimaryFocusedDark = "#87bfff";
export const ColorPrimaryPressedLight = "#0067df";
export const ColorPrimaryPressedLightHc = "#00336f";
export const ColorPrimaryPressedDark = "#66adff";
export const ColorSecondaryFocusedLight = "#e9f1fa";
export const ColorSecondaryFocusedLightHc = "#e9f1fa";
export const ColorSecondaryFocusedDark = "#374652";
export const ColorSecondaryPressedLight = "#b2d2f3";
export const ColorSecondaryPressedLightHc = "#b2d2f3";
export const ColorSecondaryPressedDark = "#11508d";
export const ColorChipDefaultBackgroundLight = "#cfd8dd";
export const ColorChipDefaultBackgroundLightHc = "#cfd8dd";
export const ColorChipDefaultBackgroundDark = "#526069";
export const ColorChipErrorBackgroundLight = "#fff0f1";
export const ColorChipErrorBackgroundLightHc = "#fff0f1";
export const ColorChipErrorBackgroundDark = "#000000";
export const ColorChipWarningBackgroundLight = "#fff3db";
export const ColorChipWarningBackgroundLightHc = "#fff3db";
export const ColorChipWarningBackgroundDark = "#000000";
export const ColorChipInfoBackgroundLight = "#e9f1fa";
export const ColorChipInfoBackgroundLightHc = "#e9f1fa";
export const ColorChipInfoBackgroundDark = "#000000";
export const ColorChipSuccessBackgroundLight = "#eeffe5";
export const ColorChipSuccessBackgroundLightHc = "#eeffe5";
export const ColorChipSuccessBackgroundDark = "#000000";
export const ColorErrorIconLight = "#cc3d45";
export const ColorErrorIconLightHc = "#a6040a";
export const ColorErrorIconDark = "#ff8484";
export const ColorErrorIconInverseLight = "#ff8484";
export const ColorErrorIconInverseLightHc = "#ff8484";
export const ColorErrorIconInverseDark = "#cc3d45";
export const ColorErrorTextLight = "#a6040a";
export const ColorErrorTextLightHc = "#a6040a";
export const ColorErrorTextDark = "#ff8484";
export const ColorErrorBackgroundLight = "#fff0f1";
export const ColorErrorBackgroundLightHc = "#fff0f1";
export const ColorErrorBackgroundDark = "#000000";
export const ColorErrorForegroundInverseLight = "#ff8484";
export const ColorErrorForegroundInverseLightHc = "#ff8484";
export const ColorErrorForegroundInverseDark = "#cc3d45";
export const ColorInfoForegroundLight = "#1665b3";
export const ColorInfoForegroundLightHc = "#11508d";
export const ColorInfoForegroundDark = "#42a1ff";
export const ColorInfoIconLight = "#1976d2";
export const ColorInfoIconLightHc = "#11508d";
export const ColorInfoIconDark = "#42a1ff";
export const ColorInfoIconInverseLight = "#42a1ff";
export const ColorInfoIconInverseLightHc = "#42a1ff";
export const ColorInfoIconInverseDark = "#1976d2";
export const ColorInfoTextLight = "#1665b3";
export const ColorInfoTextLightHc = "#11508d";
export const ColorInfoTextDark = "#42a1ff";
export const ColorInfoForegroundInverseLight = "#42a1ff";
export const ColorInfoForegroundInverseLightHc = "#42a1ff";
export const ColorInfoForegroundInverseDark = "#1976d2";
export const ColorInfoBackgroundLight = "#e9f1fa";
export const ColorInfoBackgroundLightHc = "#e9f1fa";
export const ColorInfoBackgroundDark = "#000000";
export const ColorSuccessIconLight = "#038108";
export const ColorSuccessIconLightHc = "#005603";
export const ColorSuccessIconDark = "#74c94b";
export const ColorSuccessIconInverseLight = "#74c94b";
export const ColorSuccessIconInverseLightHc = "#74c94b";
export const ColorSuccessIconInverseDark = "#038108";
export const ColorSuccessTextLight = "#038108";
export const ColorSuccessTextLightHc = "#005603";
export const ColorSuccessTextDark = "#74c94b";
export const ColorSuccessBackgroundLight = "#eeffe5";
export const ColorSuccessBackgroundLightHc = "#eeffe5";
export const ColorSuccessBackgroundDark = "#000000";
export const ColorSuccessForegroundInverseLight = "#74c94b";
export const ColorSuccessForegroundInverseLightHc = "#74c94b";
export const ColorSuccessForegroundInverseDark = "#6eb84a";
export const ColorWarningIconLight = "#ffb40e";
export const ColorWarningIconLightHc = "#805a07";
export const ColorWarningIconDark = "#ffbb27";
export const ColorWarningIconInverseLight = "#ffbb27";
export const ColorWarningIconInverseLightHc = "#ffbb27";
export const ColorWarningIconInverseDark = "#ffb40e";
export const ColorWarningTextLight = "#9e6100";
export const ColorWarningTextLightHc = "#805a07";
export const ColorWarningTextDark = "#ffe19e";
export const ColorWarningBackgroundLight = "#fff3db";
export const ColorWarningBackgroundLightHc = "#fff3db";
export const ColorWarningBackgroundDark = "#000000";
export const ColorWarningForegroundInverseLight = "#ffbb27";
export const ColorWarningForegroundInverseLightHc = "#ffbb27";
export const ColorWarningForegroundInverseDark = "#ffb40e";
export const ColorIconDefaultLight = "#526069";
export const ColorIconDefaultLightHc = "#374652";
export const ColorIconDefaultDark = "#cfd8dd";
export const ColorIconInvertedDefaultLight = "#cfd8dd";
export const ColorIconInvertedDefaultLightHc = "#cfd8dd";
export const ColorIconInvertedDefaultDark = "#526069";
export const ColorToggleOffHoverLight = "#52606914";
export const ColorToggleOffHoverLightHc = "#52606914";
export const ColorToggleOffHoverDark = "#cfd8dd14";
export const ColorToggleOffFocusLight = "#52606914";
export const ColorToggleOffFocusLightHc = "#52606914";
export const ColorToggleOffFocusDark = "#cfd8dd14";
export const ColorToggleOffPressedLight = "#5260691f";
export const ColorToggleOffPressedLightHc = "#5260691f";
export const ColorToggleOffPressedDark = "#cfd8dd1f";
export const ColorToggleOnHoverLight = "#0067df14";
export const ColorToggleOnHoverLightHc = "#0067df14";
export const ColorToggleOnHoverDark = "#66adff14";
export const ColorToggleOnFocusLight = "#0067df14";
export const ColorToggleOnFocusLightHc = "#0067df14";
export const ColorToggleOnFocusDark = "#66adff14";
export const ColorToggleOnPressedLight = "#0067df1f";
export const ColorToggleOnPressedLightHc = "#0067df1f";
export const ColorToggleOnPressedDark = "#66adff1f";
export const ColorCalloutBackgroundLight = "#00489d";
export const ColorCalloutBackgroundLightHc = "#00489d";
export const ColorCalloutBackgroundDark = "#00489d";
export const ColorWarnLight = "#b6242b";
export const ColorWarnLightHc = "#b6242b";
export const ColorWarnDark = "#ff8484";
export const ColorWarnDarkerLight = "#a6040a";
export const ColorWarnDarkerLightHc = "#a6040a";
export const ColorWarnDarkerDark = "#ffadad";
export const ColorWarnHoverLight = "#b6242b0a";
export const ColorWarnHoverLightHc = "#b6242b0a";
export const ColorWarnHoverDark = "#ff84840a";
export const ColorWarnFocusLight = "#b6242b1f";
export const ColorWarnFocusLightHc = "#b6242b1f";
export const ColorWarnFocusDark = "#ff84841f";
export const ColorWarnPressedLight = "#b6242b14";
export const ColorWarnPressedLightHc = "#b6242b14";
export const ColorWarnPressedDark = "#ff848414";
export const ColorCarouselBackgroundLight = "#f5f9fe";
export const ColorCarouselBackgroundLightHc = "#f5f9fe";
export const ColorCarouselBackgroundDark = "#1b2630";
export const ColorIconButtonHoverLight = "#52606914";
export const ColorIconButtonHoverLightHc = "#52606914";
export const ColorIconButtonHoverDark = "#cfd8dd14";
export const ColorIconButtonFocusLight = "#52606914";
export const ColorIconButtonFocusLightHc = "#52606914";
export const ColorIconButtonFocusDark = "#cfd8dd14";
export const ColorIconButtonPressedLight = "#5260691f";
export const ColorIconButtonPressedLightHc = "#5260691f";
export const ColorIconButtonPressedDark = "#cfd8dd1f";
export const ColorCodeFunctionLight = "#b748b6";
export const ColorCodeFunctionLightHc = "#8c338b";
export const ColorCodeFunctionDark = "#dc80db";
export const ColorCodeOperatorLight = "#0067df";
export const ColorCodeOperatorLightHc = "#00489d";
export const ColorCodeOperatorDark = "#66adff";
export const ColorCodeNumericLight = "#1e7f5a";
export const ColorCodeNumericLightHc = "#176245";
export const ColorCodeNumericDark = "#6ecdb6";
export const ColorCodeTextLight = "#d91153";
export const ColorCodeTextLightHc = "#a60e3f";
export const ColorCodeTextDark = "#f25a8c";
export const ColorToggleThumbOffLight = "#526069";
export const ColorToggleThumbOffLightHc = "#374652";
export const ColorToggleThumbOffDark = "#cfd8dd";
export const ColorToggleTrackOffLight = "#cfd8dd";
export const ColorToggleTrackOffLightHc = "#cfd8dd";
export const ColorToggleTrackOffDark = "#526069";
export const ColorToggleThumbOnLight = "#0067df";
export const ColorToggleThumbOnLightHc = "#00489d";
export const ColorToggleThumbOnDark = "#66adff";
export const ColorToggleTrackOnLight = "#badaff";
export const ColorToggleTrackOnLightHc = "#badaff";
export const ColorToggleTrackOnDark = "#00489d";
export const ColorToggleThumbOffDisabledLight = "#cfd8dd";
export const ColorToggleThumbOffDisabledLightHc = "#cfd8dd";
export const ColorToggleThumbOffDisabledDark = "#526069";
export const ColorToggleTrackOffDisabledLight = "#ecedee";
export const ColorToggleTrackOffDisabledLightHc = "#ecedee";
export const ColorToggleTrackOffDisabledDark = "#374652";
export const ColorToggleThumbOnDisabledLight = "#0067df47";
export const ColorToggleThumbOnDisabledLightHc = "#0067df47";
export const ColorToggleThumbOnDisabledDark = "#66adff47";
export const ColorToggleTrackOnDisabledLight = "#badaff61";
export const ColorToggleTrackOnDisabledLightHc = "#badaff61";
export const ColorToggleTrackOnDisabledDark = "#00489d61";
